import { ThemeProvider } from 'styled-components';
import { useSelector } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from './services/i18n';
import { ConfigProvider, theme } from 'antd';

import Router from './routers';
import { RootState } from './store';

import { GlobalStyle, themes } from './styles/index';

import antdTranslation from 'locales/antd';

function App() {
  const { appTheme } = useSelector((state: RootState) => state.common);

  return (
    // <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={{ ...themes[appTheme || 'theme1'], appTheme: appTheme || 'theme1' }}>
        <ConfigProvider
          locale={antdTranslation}
          theme={{
            algorithm: appTheme === 'theme2' ? theme.darkAlgorithm : theme.defaultAlgorithm,
            token: { colorPrimary: '#006EB6' }
          }}
        >
          <GlobalStyle />
          <Router />
        </ConfigProvider>
      </ThemeProvider>
    </I18nextProvider>
    // </Provider>
  );
}

export default App;
